import { render, staticRenderFns } from "./VoidCancelled.vue?vue&type=template&id=054d4814&scoped=true&"
import script from "./VoidCancelled.vue?vue&type=script&lang=js&"
export * from "./VoidCancelled.vue?vue&type=script&lang=js&"
import style0 from "./VoidCancelled.vue?vue&type=style&index=0&id=054d4814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d4814",
  null
  
)

export default component.exports